module.exports = __webpack_public_path__ + "static/media/mlogolg-kfc.180c5d8a.png";